import type { FunnelStage } from "./events";
import { track } from "./telemetry";

/**
 * Virtual page views for the ad first runs (feng shui `/fs/…`, 3D
 * walk-through `/r3d/…`). The app is a single URL, so GA4's standard
 * reports would see one long "/" session; reporting each stage as a
 * `page_view` with its own path makes the funnel readable in Reports →
 * Pages and Explorations, next to the typed product events.
 */

const PATHS: Record<FunnelStage, { path: string; title: string }> = {
  landing: { path: "/fs/land", title: "Feng shui · landing" },
  example_applied: { path: "/fs/example-applied", title: "Feng shui · example applied" },
  my_room: { path: "/fs/my-room", title: "Feng shui · my room" },
  ai_applied: { path: "/fs/ai-applied", title: "Feng shui · AI applied" },
  save: { path: "/fs/save", title: "Feng shui · save" },
  done: { path: "/fs/done", title: "Feng shui · account" },
  r3d_landing: { path: "/r3d/land", title: "3D · landing" },
  r3d_example: { path: "/r3d/example", title: "3D · showcase walk-through" },
  r3d_my_room: { path: "/r3d/my-room", title: "3D · my room" },
  r3d_own_3d: { path: "/r3d/own-3d", title: "3D · my room in 3D" },
  r3d_save: { path: "/r3d/save", title: "3D · save" },
  r3d_done: { path: "/r3d/done", title: "3D · account" },
};

let current: FunnelStage | null = null;

/** Enter a stage (idempotent for repeats of the same stage). */
export function setFunnelStage(stage: FunnelStage): void {
  if (current === stage) return;
  current = stage;
  const { path, title } = PATHS[stage];
  track("page_view", { page_path: path, page_title: title, stage });
}

export function getFunnelStage(): FunnelStage | null {
  return current;
}

/** Test-only. */
export function _resetFunnelStageForTests(): void {
  current = null;
}
